<template>
  <v-main class="vs-login-wrapper">
    <div class="vs-login-glow-1" aria-hidden="true"></div>
    <div class="vs-login-glow-2" aria-hidden="true"></div>
    <div class="vs-login-grid-bg" aria-hidden="true"></div>

    <v-container class="fill-height position-relative" fluid>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="10" md="7" lg="5" xl="4">
          <v-card class="vs-login-card px-6 px-sm-10 py-10" elevation="24">
            
            <div class="text-center mb-8">
              <div class="vs-logo-container d-flex flex-column align-center justify-center">
                <img
                  src="/veriSalvatori/logo_site.svg"
                  alt="Veri Salvatori"
                  class="vs-login-logo"
                  style="max-width: 260px; height: 38px; width: auto; object-fit: contain;"
                />
              </div>
              <div class="vs-login-subtitle">INSTITUTO MÉDICO</div>
              <h2 class="vs-section-title mt-4">Simulados TECM</h2>
              <p class="vs-section-desc mt-1">Preencha seus dados para ter acesso imediato à plataforma de simulados.</p>
            </div>

            <v-form v-model="formValid" @submit.prevent="onSubmit">
              <div class="vs-input-wrapper mb-3">
                <label class="vs-input-label">Nome e Sobrenome</label>
                <v-text-field
                  v-model="fullName"
                  :readonly="loading"
                  :rules="[rules.required]"
                  clearable
                  placeholder="Seu nome completo"
                  prepend-inner-icon="mdi-account-outline"
                  variant="outlined"
                  density="comfortable"
                  class="vs-custom-field"
                  hide-details="auto"
                ></v-text-field>
              </div>

              <div class="vs-input-wrapper mb-3">
                <label class="vs-input-label">E-mail</label>
                <v-text-field
                  v-model="email"
                  :readonly="loading"
                  :rules="[rules.required, rules.email]"
                  clearable
                  placeholder="seu.email@exemplo.com"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  density="comfortable"
                  class="vs-custom-field"
                  hide-details="auto"
                ></v-text-field>
              </div>

              <div class="vs-input-wrapper mb-4">
                <label class="vs-input-label">Telefone (WhatsApp)</label>
                <v-text-field
                  v-model="phone"
                  :readonly="loading"
                  :rules="[rules.required, rules.phone]"
                  clearable
                  placeholder="11 91234-1234"
                  prepend-inner-icon="mdi-phone-outline"
                  type="tel"
                  @input="formatPhone"
                  maxlength="13"
                  variant="outlined"
                  density="comfortable"
                  class="vs-custom-field"
                  hide-details="auto"
                ></v-text-field>
              </div>

              <v-checkbox
                v-model="lgpdConsent"
                :rules="[rules.requiredConsent]"
                class="mb-6"
                color="#537efb"
                hide-details="auto"
              >
                <template v-slot:label>
                  <div style="font-family: 'Inter', sans-serif; font-size: 13px; color: #aebeda;">
                    Concordo com a 
                    <a href="https://verisalvatori.com.br" target="_blank" @click.stop style="color: #83b2ff; text-decoration: underline;">Política de Privacidade</a>
                    (LGPD).
                  </div>
                </template>
              </v-checkbox>

              <v-btn
                :disabled="!formValid"
                :loading="loading"
                block
                class="vs-btn-submit"
                type="submit"
                elevation="4"
              >
                <span>Acessar Simulados</span>
                <v-icon end size="18" class="ml-2">mdi-arrow-right</v-icon>
              </v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    fullName: "",
    email: "",
    phone: "",
    lgpdConsent: false,
    formValid: false,
    loading: false,

    rules: {
      required: value => !!value || 'Campo Obrigatório.',
      requiredConsent: value => !!value || 'Você deve aceitar a Política de Privacidade.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail Inválido.'
      },
      phone: value => {
        const pattern = /^\d{2} \d{4,5}-\d{4}$/;
        return pattern.test(value) || 'Telefone inválido (ex: 11 91234-1234).';
      }
    },
  }),

  methods: {
    formatPhone(val) {
      // Utiliza o this.phone caso val seja um evento (o que causa o erro val.replace is not a function)
      let currentVal = typeof val === 'string' ? val : this.phone;
      if (!currentVal) return;
      
      currentVal = String(currentVal);
      let digits = currentVal.replace(/\D/g, '');
      if (digits.length > 11) digits = digits.substring(0, 11);
      
      let formatted = digits;
      if (digits.length > 2 && digits.length <= 6) {
        formatted = digits.replace(/^(\d{2})(\d+)/, '$1 $2');
      } else if (digits.length > 6 && digits.length <= 10) {
        formatted = digits.replace(/^(\d{2})(\d{4})(\d+)/, '$1 $2-$3');
      } else if (digits.length === 11) {
        formatted = digits.replace(/^(\d{2})(\d{5})(\d{4})/, '$1 $2-$3');
      }
      
      // Atualiza o valor garantindo a reatividade
      this.phone = formatted;
    },
    async onSubmit() {
      if (!this.formValid) return;

      this.loading = true;
      const payload = {
        action: 'saveLead',
        fullName: this.fullName,
        email: this.email,
        phone: this.phone,
        date: new Date().toISOString()
      };
      
      try {
        await this.$store.dispatch('postLeadData', payload);
        this.$router.push('/tecm-sim-exp-questions');
      } catch (error) {
        console.error("Erro ao salvar dados:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.vs-login-wrapper {
  position: relative;
  background-color: #030a1a !important;
  min-height: 100vh;
  overflow: hidden;
  color: #fafaff;
}

.vs-login-glow-1 {
  position: absolute;
  top: -150px;
  right: -100px;
  width: 650px;
  height: 650px;
  background: radial-gradient(circle at center, rgba(49, 95, 216, 0.25) 0%, rgba(3, 10, 26, 0) 70%);
  pointer-events: none;
  filter: blur(50px);
}

.vs-login-glow-2 {
  position: absolute;
  bottom: -150px;
  left: -100px;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle at center, rgba(83, 126, 251, 0.18) 0%, rgba(3, 10, 26, 0) 70%);
  pointer-events: none;
  filter: blur(60px);
}

.vs-login-grid-bg {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(169, 188, 229, 0.08) 1px, transparent 1px);
  background-size: 32px 32px;
  pointer-events: none;
  opacity: 0.6;
}

.vs-login-card {
  position: relative;
  background: rgba(5, 18, 46, 0.8) !important;
  backdrop-filter: blur(28px) saturate(140%) !important;
  -webkit-backdrop-filter: blur(28px) saturate(140%) !important;
  border: 1px solid rgba(169, 188, 229, 0.18) !important;
  box-shadow: 0 25px 60px -10px rgba(0, 0, 0, 0.65), 0 0 50px -10px rgba(49, 95, 216, 0.2) !important;
  border-radius: 28px !important;
  color: #fafaff;
  z-index: 2;
}

.vs-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vs-login-logo {
  max-width: 250px;
  height: auto;
  filter: drop-shadow(0 4px 20px rgba(131, 178, 255, 0.18));
}

.vs-login-subtitle {
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.34em;
  color: #a5bada;
  margin-top: 9px;
  text-transform: uppercase;
}

.vs-section-title {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

.vs-section-desc {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #9eb1d5;
  line-height: 1.5;
}

.vs-input-wrapper {
  position: relative;
}

.vs-input-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: #aab8d4;
  margin-bottom: 6px;
}

.vs-btn-submit {
  height: 50px !important;
  background: linear-gradient(135deg, #315fd8 0%, #4f80fc 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  letter-spacing: 0.03em !important;
  border-radius: 14px !important;
  box-shadow: 0 8px 24px -4px rgba(49, 95, 216, 0.5) !important;
  text-transform: none !important;
  transition: transform 0.2s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.2s cubic-bezier(0.22, 1, 0.36, 1) !important;
}

.vs-btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px -4px rgba(49, 95, 216, 0.65) !important;
}

.vs-btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.vs-btn-submit:disabled,
.vs-btn-submit.v-btn--disabled {
  opacity: 0.55 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.vs-btn-submit:disabled *,
.vs-btn-submit.v-btn--disabled * {
  color: #ffffff !important;
}

:deep(.vs-custom-field .v-field) {
  background-color: rgba(3, 10, 26, 0.5) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  border-color: rgba(169, 188, 229, 0.25) !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}

:deep(.vs-custom-field .v-field--focused) {
  border-color: #537efb !important;
  box-shadow: 0 0 0 3px rgba(83, 126, 251, 0.25) !important;
}

:deep(.vs-custom-field input) {
  color: #ffffff !important;
}

:deep(.vs-custom-field .v-icon) {
  color: #8296b9 !important;
}

:deep(.vs-custom-field .v-field--focused .v-icon) {
  color: #83b2ff !important;
}
</style>
